export default "__VITE_ASSET__mP7vb1Gd__"